enum Material {
    Other = -1000000,
    NewComposite = -1000001,
    ZoneBoundary = -1000002,
    CoveredOpening = -1000003,
    Various = -1000004
}

export default Material;